import UseCase from "../../core/useCase/UseCase";
import { FlexPackageRepository } from "../repository/FlexPackageRepository";
import { FlexProduct } from "../entity/FlexPackage";

export default class GetFlexPackageProducts extends UseCase<
  FlexProduct[],
  GetFlexPackageProductsParams
> {
  repository: FlexPackageRepository;

  constructor(repository: FlexPackageRepository) {
    super();
    this.repository = repository;
  }

  execute = (params: GetFlexPackageProductsParams) =>
    this.repository.getProducts(params.appPid, params.packageId);
}

export class GetFlexPackageProductsParams {
  appPid?: number;
  packageId?: string;

  constructor(appPid?: number, packageId?: string) {
    this.appPid = appPid;
    this.packageId = packageId;
  }
}
